<div class="divcontent">
    <div style="text-align: end;">
        <mat-icon class="closeModal" [mat-dialog-close]>cancel</mat-icon>
    </div>
    <mat-form-field appearance="outline" class="col-12">
        <mat-label>Revisión comentario</mat-label>
        <textarea matInput maxlength="30" placeholder="Comentario para revisión" [(ngModel)]="comment" ></textarea>
    </mat-form-field>
    <div style="text-align: center;">
        <button class="button" [disabled]="comment == ''" (click)="sendComment()">Enviar Comentario</button>
    </div>
</div>
